<template>
	<div>
        <!-- DESKTOP layout -->
        <div  v-if="$mq !== 'mobile'"  style="padding:5px;">
            <div class="text-left"  style="overflow:hidden; border: 2px solid black; margin: auto; width: 80%; padding:20px; background-color:whitesmoke;">
                <table  width=100%  style="max-width:800px; table-layout:fixed; margin-left:auto; margin-right:auto;">
                    <tbody>
                        <tr>
                            <td  style='width:260px; vertical-align:top;'>
                                <img  :src="api_url + '/api/file_by_ddna/' + $route.params.ddna + '/show'"  style="max-width:250px; max-height:750px;" />
                            </td>
                            <td>
                                <table  width=100%  style="max-width:650px; table-layout:fixed; margin-left:auto; margin-right:auto;">
                                    <tbody>
                                        <tr>
                                            <td  style='width:128px; padding-left:5px; padding-right:20px; text-align:right;'>Name:</td>
                                            <td><b>{{ file.name }}</b></td>
                                        </tr>
                                        <tr>
                                            <td  style='padding-left:5px; padding-right:20px; text-align:right;'>Size:</td>
                                            <td><b>{{ (file.size / (1024 * 1024)).toFixed(2) }} MB</b></td>
                                        </tr>
                                        <tr>
                                            <td  style='padding-left:5px; padding-right:20px; text-align:right;'>Created:</td>
                                            <td v-if="file.timestamp"><b>{{ file.timestamp | moment("HH:mm:ss, Do MMM YYYY") }}</b></td>
                                        </tr>
                                        <tr><td colspan=2><small>&nbsp;</small></td></tr>

                                        <!-- CONTENT HASH -->
                                        <tr  style="overflow: hidden;">
                                            <td  style='padding-left:5px; padding-right:20px; text-align:right;'>Content DDNA:</td>
                                            <td  style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                                <small class="text-monospace">{{ file.hash }}</small>
                                            </td>
                                        </tr>
                                        <tr v-if="file_checking == true">
                                            <td  style='padding-left:5px; padding-right:20px; text-align:right;'>
                                                <span class="btn btn-xs btn-info"  style='font-variant:small-caps;'>checking ...</span>
                                            </td>
                                            <td><small class="text-muted">please wait</small></td>
                                        </tr>
                                        <tr v-else-if="file_transaction">
                                            <td  v-if="file_transaction.memo == file.hash"
                                                    style='padding-left:5px; padding-right:20px; text-align:right;'>
                                                <span class="btn btn-xs btn-success"  style='font-variant:small-caps;'>verified</span>
                                            </td>
                                            <td  v-else
                                                    style='padding-left:5px; padding-right:20px; text-align:right;'>
                                                <span class="btn btn-xs btn-danger"  style='font-variant:small-caps;'>error</span>
                                            </td>
                                            <td>
                                                {{ file_transaction.created_at | moment("HH:mm:ss, Do MMM YYYY") }}
                                                <br>
                                                <a :href="explorer_link + file.stellar_tx_id" target='_blank'>Check using external tool</a>
                                            </td>
                                        </tr>
                                        <tr v-else >
                                            <td  style='padding-left:5px; padding-right:20px; text-align:right;'>
                                                <span class="btn btn-xs btn-warning"  style='font-variant:small-caps;'>not found</span>
                                            </td>
                                            <td></td>
                                        </tr>
                                        <tr><td colspan=2><small>&nbsp;</small></td></tr>

                                        <!-- OWNER HASH -->
                                        <tr  style="overflow: hidden; text-overflow: ellipsis;">
                                            <td  style='padding-left:5px; padding-right:20px; text-align:right;'>Owner DDNA:</td>
                                            <td  style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                                <small class="text-monospace">{{ file.owner_hash }}</small>
                                            </td>
                                        </tr>
                                        <tr v-if="owner_checking == true">
                                            <td  style='padding-left:5px; padding-right:20px; text-align:right;'>
                                                <span class="btn btn-xs btn-info"  style='font-variant:small-caps;'>checking ...</span>
                                            </td>
                                            <td><small class="text-muted">please wait</small></td>
                                        </tr>
                                        <tr v-else-if="owner_transaction">
                                            <td  v-if="owner_transaction.memo == file.owner_hash"
                                                    style='padding-left:5px; padding-right:20px; text-align:right;'>
                                                <span class="btn btn-xs btn-success"  style='font-variant:small-caps;'>verified</span>
                                            </td>
                                            <td  v-else
                                                    style='padding-left:5px; padding-right:20px; text-align:right;'>
                                                <span class="btn btn-xs btn-danger"  style='font-variant:small-caps;'>error</span>
                                            </td>
                                            <td>
                                                {{ owner_transaction.created_at | moment("HH:mm:ss, Do MMM YYYY") }}
                                                <br>
                                                <a :href="explorer_link + file.owner_stellar_tx_id" target='_blank'>Check using external tool</a>
                                            </td>
                                        </tr>
                                        <tr v-else >
                                            <td  style='padding-left:5px; padding-right:20px; text-align:right;'>
                                                <span class="btn btn-xs btn-warning"  style='font-variant:small-caps;'>not found</span>
                                            </td>
                                            <td></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- MOBILE layout -->
        <div  v-else                   style="padding:5px;">
            <div class="text-left"  style="overflow:hidden; border: 2px solid black; margin: auto; width: 100%; padding:5px; background-color:whitesmoke;">
                <table  width=100%  style="max-width:650px; table-layout:fixed; margin-left:auto; margin-right:auto;">
                    <tbody>
                        <tr>
                            <td  style='width:100px; padding-left:5px; padding-right:10px; text-align:right;'>Name:</td>
                            <td><b>{{ file.name }}</b></td>
                        </tr>
                        <tr>
                            <td  style='padding-left:5px; padding-right:20px; text-align:right;'>Size:</td>
                            <td><b>{{ (file.size / (1024 * 1024)).toFixed(2) }} MB</b></td>
                        </tr>
                        <tr>
                            <td  style='padding-left:5px; padding-right:20px; text-align:right;'>Created:</td>
                            <td v-if="file.timestamp"><b>{{ file.timestamp | moment("HH:mm:ss, Do MMM YYYY") }}</b></td>
                        </tr>
                        <tr><td colspan=2><small>&nbsp;</small></td></tr>

                        <!-- CONTENT HASH -->
                        <tr  style="overflow: hidden;">
                            <td  style='padding-left:5px; padding-right:20px; text-align:right;'>Content DDNA:</td>
                            <td  style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                <small class="text-monospace">{{ file.hash }}</small>
                            </td>
                        </tr>
                        <tr v-if="file_checking == true">
                            <td  style='padding-left:5px; padding-right:20px; text-align:right;'>
                                <span class="btn btn-xs btn-info"  style='font-variant:small-caps;'>checking ...</span>
                            </td>
                            <td><small class="text-muted">please wait</small></td>
                        </tr>
                        <tr v-else-if="file_transaction">
                            <td  v-if="file_transaction.memo == file.hash"
                                    style='padding-left:5px; padding-right:20px; text-align:right;'>
                                <span class="btn btn-xs btn-success"  style='font-variant:small-caps;'>verified</span>
                            </td>
                            <td  v-else
                                    style='padding-left:5px; padding-right:20px; text-align:right;'>
                                <span class="btn btn-xs btn-danger"  style='font-variant:small-caps;'>error</span>
                            </td>
                            <td>
                                {{ file_transaction.created_at | moment("HH:mm:ss, Do MMM YYYY") }}
                                <br>
                                <a :href="explorer_link + file.stellar_tx_id" target='_blank'>Check using external tool</a>
                            </td>
                        </tr>
                        <tr v-else >
                            <td  style='padding-left:5px; padding-right:20px; text-align:right;'>
                                <span class="btn btn-xs btn-warning"  style='font-variant:small-caps;'>not found</span>
                            </td>
                            <td></td>
                        </tr>
                        <tr><td colspan=2><small>&nbsp;</small></td></tr>

                        <!-- OWNER HASH -->
                        <tr  style="overflow: hidden; text-overflow: ellipsis;">
                            <td  style='padding-left:5px; padding-right:20px; text-align:right;'>Owner DDNA:</td>
                            <td  style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                <small class="text-monospace">{{ file.owner_hash }}</small>
                            </td>
                        </tr>
                        <tr v-if="owner_checking == true">
                            <td  style='padding-left:5px; padding-right:20px; text-align:right;'>
                                <span class="btn btn-xs btn-info"  style='font-variant:small-caps;'>checking ...</span>
                            </td>
                            <td><small class="text-muted">please wait</small></td>
                        </tr>
                        <tr v-else-if="owner_transaction">
                            <td  v-if="owner_transaction.memo == file.owner_hash"
                                    style='padding-left:5px; padding-right:20px; text-align:right;'>
                                <span class="btn btn-xs btn-success"  style='font-variant:small-caps;'>verified</span>
                            </td>
                            <td  v-else
                                    style='padding-left:5px; padding-right:20px; text-align:right;'>
                                <span class="btn btn-xs btn-danger"  style='font-variant:small-caps;'>error</span>
                            </td>
                            <td>
                                {{ owner_transaction.created_at | moment("HH:mm:ss, Do MMM YYYY") }}
                                <br>
                                <a :href="explorer_link + file.owner_stellar_tx_id" target='_blank'>Check using external tool</a>
                            </td>
                        </tr>
                        <tr v-else >
                            <td  style='padding-left:5px; padding-right:20px; text-align:right;'>
                                <span class="btn btn-xs btn-warning"  style='font-variant:small-caps;'>not found</span>
                            </td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
                <div style='width:100%; padding-top:10px; text-align:center; vertical-align:top;'>
                    <img  :src="api_url + '/api/file_by_ddna/' + $route.params.ddna + '/show'"  
                          style="margin-left: auto; margin-right: auto; max-width:250px; max-height:750px;" />
                </div>
            </div>
        </div>
	</div>
</template>

<script>
    var stellar_sdk = require("stellar-sdk");

    export default {
        components: {
        },

        data() {
            return {
                api_url:           this.$store.getters.API_URL,
                file:              '',
                explorer_link:     '',

                owner_checking:    true,
                owner_transaction: null,
                file_checking:     true,
                file_transaction:  null,
            };
        },

        computed: {
        },

        watch: {
            // Get transaction details from Stellar Network
            file(n) {
                this.get_file_transaction(n.stellar_tx_id);
                this.get_owner_transaction(n.owner_stellar_tx_id);
            },
        },

		created() {
            if (process.env.VUE_APP_ENV != "production") {
                this.explorer_link = 'https://testnet.steexp.com/tx/';
            }
            else {
                this.explorer_link = 'https://steexp.com/tx/';
            }

            // Connect Stellar SDK
			if (this.$route.params.ddna) {
                this.get_file(this.$route.params.ddna)
			}

            this.stellar_server = new stellar_sdk.Server(this.$store.getters.GET_STELLAR_NETWORK_URL);
		},

        mounted() {
        },
		
        methods: {
			is_logged_in() {
				var status     = false;
				this.api_token = localStorage.getItem('api_token');
				
				if (this.api_token  &&  this.api_token.length == 64) {
					status = true;
				}
					
				return status;
			},

            // Get Users Files
            get_file(ddna) {
				var vm       = this;
				var is_valid = false;

                if (ddna  &&  ddna.length == 6) {
                    var regex = /[0-9A-Fa-f]{6}/g;
                    if (ddna.match(regex) ){
                        is_valid = true;
                    }
                }

                if (is_valid == true) {
                    //console.log('Getting file');
                    // Call API for files
                    this.axios.get('api/file_by_ddna/'+ ddna)
                    .then(response => {
                        vm.file = response.data.records[0];
                    })
                    .catch(error => {
                        var error_msg = '';
                        if (error.response.data.message) {
                            error_msg = error_msg + error.response.data.message + "<br>";	
                        }
                        
                        if (error.response.data.error) {
                            Object.keys(error.response.data.error).forEach(key => {
                                error_msg = error_msg + error.response.data.error[key] + "<br>";

                                // load api errors into client errors
                                this.errors.add({
                                    field: key,
                                    msg:   error.response.data.error[key],
                                });
                            });
                        }

                        this.$notify({
                            group: "fs_danger",
                            title: "Error",
                            text: error_msg,
                            type: "error"
                        });
                    });
                }
			},

            b64decode(str) {		
                return atob(str);
            },
            toHex(str) {
                var hex = '';
                var c   = '';

                for (var i=0; i < str.length; i++) {
                    c = str.charCodeAt(i).toString(16);
                    if (c.length < 2) {
                        hex += '0';
                    }
                    hex += ''+str.charCodeAt(i).toString(16);
                }

                return hex;
            },

            get_file_transaction: async function(id) {
                let _self = this;

                _self.file_checking    = true;
                _self.file_transaction = null;
    
                // Fetch
                if (id != null  &&  id != '') {
                    await _self.stellar_server.transactions()
                        .transaction(id)
                        .call()
                        .then(function (result) {
                            //console.log('SDK result =', result);
                            // Base64 decode memo
                            if (result.hasOwnProperty('memo')) {
                                result.memo = _self.toHex(_self.b64decode(result.memo)); 
                            }

                            _self.file_checking    = false;
                            _self.file_transaction = result;
                        })
                        .catch(function (error) {
                            _self.file_checking    = false;
                            //console.log('SDK Error:', error);
                        });    
                }
                else {
                    _self.file_checking = false;
                }
            },  

            get_owner_transaction: async function(id) {
                let _self = this;

                _self.owner_checking    = true;
                _self.owner_transaction = null;
    
                // Fetch
                if (id != null  &&  id != '') {
                    await _self.stellar_server.transactions()
                        .transaction(id)
                        .call()
                        .then(function (result) {
                            //console.log('Owner SDK result =', result);
                            // Base64 decode memo
                            if (result.hasOwnProperty('memo')) {
                                result.memo = _self.toHex(_self.b64decode(result.memo)); 
                            }

                            _self.owner_checking    = false;
                            _self.owner_transaction = result;
                        })
                        .catch(function (error) {
                            _self.owner_checking    = false;
                            //console.log('SDK Error:', error);
                        });    
                }
                else {
                    _self.owner_checking = false;
                }
            },  
        }
    };
</script>
